module.exports = __webpack_public_path__ + "static/media/wait.46a43171.svg";